import { withInstall } from '@sgui-plus/utils/with-install'
import Switch from './src/switch.vue'

export const SgSwitch = withInstall(Switch)
export default SgSwitch

export * from './src/switch'
